import React, { useEffect, useState } from "react"
import Navbar from "../../../atoms/navbar"
import { useNavigate, useParams } from "react-router"

import { Layout, Alert, Collapse, Form, AutoComplete, Input, Row, Col, Select, Checkbox, Button, Descriptions, message, Radio, Modal, Affix, Timeline, Space } from "antd"
import { use } from "react"
import { QuestionOutlined } from "@ant-design/icons"
import { requestToken } from "../../../auth/AuthServices"
import HeaderFarms from "../../../utils/header_farms"
import { useMsal, useIsAuthenticated } from "@azure/msal-react"
import { loginRequest } from "../../../config/api.config"
import API from "../../../services"
import { Block, Confirm, Report, Loading } from "notiflix"
import moment from "moment"

export default function ViewBidding() {
  const [items, setItems] = useState([])
  const [vendors, setVendors] = useState([])
  const [biddingHdr, setBiddingHdr] = useState({})
  const [biddingApproval, setBiddingApproval] = useState([])
  const { instance, accounts } = useMsal()
  const [currentSession, setCurrentSession] = useState(JSON.parse(localStorage.getItem("session_signin")))
  const [approvalButton, setApprovalButton] = useState(false)
  const [isModalRejectVisible, setIsModalRejectVisible] = useState(false)
  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false)
  const [comment, setComment] = useState("")

  const [reasonReject, setReasonReject] = useState("")

  const isAuthenticated = useIsAuthenticated()
  let navigate = useNavigate()

  const { Panel } = Collapse
  const { TextArea } = Input

  let { id } = useParams()

  const formStatus = "view"

  const getDetailBidding = async () => {
    const request = {
      ...loginRequest,
      account: accounts[0],
    }
    const responseToken = await instance.acquireTokenSilent(request).catch(e => {
      console.error("Token acquisition failed", e)
      throw e
    })
    const accessToken = responseToken.accessToken
    const headers = HeaderFarms(accessToken)

    const response = await API.BiddingDetail(headers, id)
    if (response.code === 200) {
      const data = await response.data
      setBiddingHdr(data.biddingHdr)
      setItems(data.biddingItem)
      setVendors(data.biddingVendor)
      setBiddingApproval(data.approval.data.detail)
      checkApprovalButton(data.approval.data.detail)
      console.log(data.approval.data.detail, "bidding approval")
    } else {
      console.error("Error fetching bidding details:", response.statusText)
    }
  }

  function checkApprovalButton(approvalList) {
    console.log("Checking approval button for current session:", currentSession)
    approvalList.forEach(approval => {
      if (approval.approver_id === currentSession?.nik && !approval.status && !approval.rejected) {
        setApprovalButton(true)
      }
    })
  }

  const onClickApprove = async () => {
    Loading.standard("Approving bidding...")
    const request = {
      ...loginRequest,
      account: accounts[0],
    }
    const responseToken = await instance.acquireTokenSilent(request).catch(e => {
      console.error("Token acquisition failed", e)
      throw e
    })
    const accessToken = responseToken.accessToken
    const headers = HeaderFarms(accessToken)
    for (const approval of biddingApproval) {
      if (approval.approver_id === currentSession.nik && !approval.status && !approval.rejected) {
        try {
          const data = {
            id: approval.id ?? approval._id,
            deputy: false,
          }
          const dataCommnet = {
            fullname: approval.approver.fullname,
            nik: approval.approver.nik,
            comment: comment,
            biddingID: biddingHdr.id_record,
          }

          console.log("Approval data to be sent:", dataCommnet)
          const responseComment = await API.AddComment(headers, dataCommnet)
          const response = await API.ApprovalApproved(headers, data)
          if (response.code === 200) {
            Loading.remove()
            message.success("Bidding approved successfully")
            navigate("/wf/pending")
          } else {
            Loading.remove()
            console.log("response approval")
            message.error("Failed to approve bidding: " + response.error)
          }
        } catch (error) {
          Loading.remove()

          // Cek apakah API mengirimkan response error
          if (error.response && error.response.data) {
            const apiError = error.response.data

            console.error("API Error:", apiError)

            message.error(apiError.error || apiError.status || "Terjadi kesalahan saat approve bidding")
          } else {
            // Jika error bukan dari API (misal network error)
            console.error("Unexpected Error:", error)
            message.error(error.message || "Terjadi kesalahan tak terduga.")
          }
        }
      }
    }
  }

  const addComment = async () => {
    Loading.standard("Approving bidding...")
    const request = {
      ...loginRequest,
      account: accounts[0],
    }
    const responseToken = await instance.acquireTokenSilent(request).catch(e => {
      console.error("Token acquisition failed", e)
      throw e
    })
    const accessToken = responseToken.accessToken
    const headers = HeaderFarms(accessToken)
    for (const approval of biddingApproval) {
      if (approval.approver_id === currentSession.nik && !approval.status && !approval.rejected) {
        try {
          const dataCommnent = {
            fullname: approval.approver.fullname,
            nik: approval.approver.nik,
            comment: comment,
            biddingID: biddingHdr.id_record,
          }

          console.log("Approval data to be sent:", dataCommnent)
          const responseComment = await API.AddComment(headers, dataCommnent)
          Loading.remove()
          if (responseComment.code === 200) {
            const newComment = {
              name: approval.approver.fullname,
              nik: approval.approver.nik,
              comment: comment,
              _id: Date.now().toString(), // simple unique ID
              date: new Date().toISOString(),
            }
            window.location.reload()
            Loading.remove()
          } else {
            Loading.remove()
            message.error("Failed to approve bidding: " + responseComment.error)
          }
        } catch (error) {
          Loading.remove()
          console.error("Gagal mengambil detail bidding:", error)
        }
      }
      Loading.remove()
    }

    Loading.remove()
  }

  const onClickReject = async () => {
    Loading.standard("Rejecting bidding...")
    const request = {
      ...loginRequest,
      account: accounts[0],
    }
    const responseToken = await instance.acquireTokenSilent(request).catch(e => {
      console.error("Token acquisition failed", e)
      throw e
    })
    const accessToken = responseToken.accessToken
    const headers = HeaderFarms(accessToken)
    for (const approval of biddingApproval) {
      if (approval.approver_id === currentSession.nik && !approval.status && !approval.rejected) {
        try {
          const data = {
            id: approval.id,
            reason: reasonReject,
          }
          const response = await API.ApprovalReject(headers, data)
          if (response.code === 200) {
            message.success("Bidding Rejected successfully")
            Loading.remove()
            navigate("/wf/pending")
          } else {
            Loading.remove()
            message.error("Failed to approve bidding: " + response.error)
          }
        } catch (error) {
          Loading.remove()
          console.error("Gagal mengambil detail bidding:", error)
        }
      }
    }
  }

  async function getUser(token) {
    try {
      let user = await API.getUserCredential(HeaderFarms(token), {
        access_token: token,
      })
      setCurrentSession(user)
    } catch (error) {
      console.error(error)
    }
  }

  function RequestToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    }

    instance
      .acquireTokenSilent(request)
      .then(response => {
        if (!currentSession) {
          getUser(response.accessToken)
        }
      })
      .catch(e => {
        handleLogin(instance)
        console.error(e)
      })
  }

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then(() => {})
      .catch(e => {
        console.error(e)
      })
  }

  const formatNumber = value => {
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 4,
    }).format(value)
  }

  useEffect(() => {
    RequestToken()
    if (id) {
      getDetailBidding()
    } else {
      message.error("Bidding ID is required to view details.")
    }
  }, [id, currentSession])
  return (
    <>
      <Navbar title="Create" back={true} subtitle="Bidding" navigate="/bidding/history"></Navbar>
      <div className="container-fluid white-back-cr">
        <Form layout="vertical" autoComplete="off" size="small" initialValues={{ items }}>
          <div className="container p-3" style={{ alignSelf: "center" }}>
            <div className="row">
              <div className="col-md-12">
                <Collapse className="collapse_sr" expandIconPosition={"end"} bordered={true} defaultActiveKey={["0", "1", "2", "3", "4", "5"]}>
                  <Panel style={{ background: "#fce8b6" }} header={<b>Information</b>} key="1">
                    <div className="row mt-3">
                      <div className="col-md-12">
                        {biddingHdr && (
                          <Descriptions size="small" bordered title="Information" className="mb-4">
                            <Descriptions.Item label="Form ID">{biddingHdr.id_record}</Descriptions.Item>
                            <Descriptions.Item label="Created at">{moment(biddingHdr.created_at).format("LLL")}</Descriptions.Item>
                          </Descriptions>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label style={{ fontSize: 15, fontWeight: "bold" }} className="mb-3">
                          Approval Status
                        </label>
                        {biddingApproval.map((approval, index) => {
                          let alertProps = {}

                          if (approval.status) {
                            alertProps = { message: "Approved", type: "success" }
                          } else if (!approval.status && !approval.rejected) {
                            alertProps = { message: "Pending", type: "warning" }
                          } else if (approval.rejected) {
                            alertProps = { message: "Rejected", type: "error" }
                          }

                          return (
                            <Timeline key={index}>
                              <Timeline.Item>
                                {approval.approver?.fullname}
                                <Alert {...alertProps} className="mt-1 p-1" showIcon />
                              </Timeline.Item>
                            </Timeline>
                          )
                        })}
                      </div>
                    </div>
                  </Panel>
                  <Panel style={{ background: "#fce8b6" }} header={<b>Comments</b>} key="1">
                    <div className="row">
                      <div className="col">
                        {Array.isArray(biddingHdr?.comments) && biddingHdr.comments.length > 0 ? (
                          biddingHdr.comments.map((comment, index) => (
                            <Timeline key={index} style={{ marginBottom: 5 }}>
                              <Timeline.Item>
                                {comment?.name} ({comment?.nik}) - {moment(comment?.date).format("LLL")}
                                <text style={{ paddingLeft: 10 }} className="d-block">
                                  {comment?.comment}
                                </text>
                              </Timeline.Item>
                            </Timeline>
                          ))
                        ) : (
                          <p style={{ fontStyle: "italic", color: "#888" }}>No comments yet</p>
                        )}
                        <div className="d-flex mt-2" style={{ width: "50%" }}>
                          <Input onChange={e => setComment(e.target.value)} className="me-2" placeholder="Add a comment..." />
                          <Button type="primary" onClick={addComment}>
                            Send
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Panel>
                  <Panel style={{ background: "#fce8b6" }} header={<b>Summary</b>} key="1">
                    <Row gutter={10} className="mb-1">
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item label="Description" rules={[{ required: true, message: "Please enter" }]}>
                          <TextArea rows={4} value={biddingHdr.description} disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item label="Req Number" rules={[{ required: false, message: "Please input Req Number" }]}>
                          <Input value={biddingHdr.pr_num} disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  <Panel style={{ background: "#fce8b6" }} header={<b>Vendor</b>} key="3">
                    {vendors.map((vendor, index) => {
                      return (
                        <div className="mb-5">
                          <div className="alert alert-warning d-flex justify-content-between w-100">
                            <div style={{ flex: 1 }}>
                              {vendor.vendor_name} - {vendor.quotation_number}
                            </div>
                          </div>
                          <Row gutter={10} className="mb-1">
                            <Col>
                              <Form.Item
                                label="PIC"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input ",
                                  },
                                ]}
                              >
                                <Input value={vendor.pic} disabled></Input>
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Telp"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input value={vendor.telp} disabled></Input>
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Currency"
                                rules={[
                                  {
                                    required: true,
                                  },
                                ]}
                              >
                                <Input value={vendor?.currency} disabled></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={10} className="mb-1">
                            <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                              <Form.Item
                                label="Address"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input ",
                                  },
                                ]}
                              >
                                <Input.TextArea disabled rows={4} style={{ width: "100%" }} value={vendor.address} />
                              </Form.Item>
                            </Col>
                          </Row>
                          <table className="table table-bordered table-striped table-hover">
                            <thead>
                              <tr>
                                <th>Items</th>
                                <th>Qty</th>
                                <th>Price before</th>
                                <th>Price after</th>
                                <th>Total Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vendor.items?.map((item, indexitem) => (
                                <tr key={indexitem}>
                                  <td>{item.name}</td>
                                  <td>{item.qty}</td>
                                  <td>{formatNumber(item.price_before)}</td>
                                  <td>{formatNumber(item.price_after)}</td>
                                  <td>{formatNumber(item.total_price)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <hr />
                          <div>
                            <div className="d-flex justify-content-between w-100">
                              <div>Total ({vendor?.currency})</div>
                              <div>{formatNumber(vendor.total_price)}</div>
                            </div>
                            <div className="d-flex justify-content-between w-100">
                              <div>Pajak ({vendor?.currency})</div>
                              <div>{formatNumber(Math.round(vendor.tax_price))}</div>
                            </div>
                            <div className="d-flex justify-content-between w-100">
                              <div>Grand Total ({vendor?.currency})</div>
                              <div>{formatNumber(Math.round(vendor.grand_total))}</div>
                            </div>
                          </div>
                          <hr />

                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Discount ({vendor?.currency})</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={formatNumber(vendor.discount_price)}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Pajak</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.tax_price}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Payment</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.payment_method}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Franco</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.franco}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Warranty</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.warranty}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Duration</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.payment_term}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div className=" row">
                            <label className="col-md-3 col-sm-12">Description</label>
                            <div className="col-md-9 col-sm-12">
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input",
                                  },
                                ]}
                              >
                                <Input disabled value={vendor.information}></Input>
                              </Form.Item>
                            </div>
                          </div>
                          <div style={{ marginBottom: "100px" }}></div>
                        </div>
                      )
                    })}
                  </Panel>

                  <Panel style={{ background: "#fce8b6" }} header={<b>Vendor Finalisation</b>} key="3">
                    <Row gutter={10} className="mb-1">
                      <Col>
                        <Form.Item
                          label="Selected Vendor"
                          rules={[
                            {
                              required: true,
                              message: "Please input",
                            },
                          ]}
                        >
                          <Input disabled={true} value={biddingHdr.vendor_selected} />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          label="Value"
                          rules={[
                            {
                              required: true,
                              message: "Please input",
                            },
                          ]}
                        >
                          <Input disabled={true} value={formatNumber(biddingHdr.value)} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10} className="mb-1">
                      <Col>
                        <Form.Item label="Additional Information">
                          <Input.TextArea disabled value={biddingHdr.information}></Input.TextArea>
                        </Form.Item>
                      </Col>
                    </Row>
                    <div>
                      <h4>Attachment</h4>
                      {biddingHdr.attachment?.map((attachment, index) => (
                        <div key={index} className="mb-2">
                          <a href={`https://farms-bidding-approval.s3.ap-southeast-3.amazonaws.com/${attachment}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            {attachment}
                          </a>
                        </div>
                      ))}
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </div>
          </div>
        </Form>
        <div className="row mt-4">
          <div className="col-md-12">
            <Affix offsetBottom={10}>
              <Form.Item className="text-center">
                <Space>
                  {approvalButton && (
                    <>
                      <Button type="primary" className="m-3" size="middle" htmlType="button" onClick={() => setIsModalApproveVisible(true)}>
                        Approve
                      </Button>
                      <Button type="primary" danger size="middle" htmlType="submit" onClick={() => setIsModalRejectVisible(true)}>
                        Reject
                      </Button>
                    </>
                  )}
                  <Button type="secondary" danger size="middle" htmlType="submit" className="ml-3" onClick={() => navigate("/bidding/view/print/" + id)}>
                    View
                  </Button>
                </Space>
              </Form.Item>
            </Affix>
            <Modal title="Write the reason" footer={null} visible={isModalRejectVisible} onOk={null} onCancel={() => setIsModalRejectVisible(false)}>
              <Form name="basic" wrapperCol={{ span: 24 }} initialValues={{ remember: true }} onFinish={onClickReject} autoComplete="off" layout="vertical">
                <Form.Item
                  label=""
                  name="message"
                  rules={[
                    {
                      required: false,
                      message: "Please input your Message!",
                    },
                  ]}
                >
                  <Input.TextArea showCount style={{ height: "150px", width: "100%" }} minLength={50} onChange={e => setReasonReject(e.target.value)} />
                </Form.Item>
                <Form.Item
                  className="mt-3"
                  wrapperCol={{
                    xs: {
                      offset: 8,
                      span: 18,
                    },
                    sm: {
                      offset: 7,
                      span: 18,
                    },
                    lg: { offset: 8, span: 18 },
                  }}
                >
                  <Button type="primary" htmlType="button" onClick={onClickReject}>
                    Reject
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
            <Modal title="Approve Comment" footer={null} visible={isModalApproveVisible} onOk={null} onCancel={() => setIsModalApproveVisible(false)}>
              <Form name="basic" wrapperCol={{ span: 24 }} initialValues={{ remember: true }} onFinish={onClickReject} autoComplete="off" layout="vertical">
                <Form.Item
                  label=""
                  name="message"
                  rules={[
                    {
                      required: false,
                      message: "Please input your Message!",
                    },
                  ]}
                >
                  <Input.TextArea showCount style={{ height: "150px", width: "100%" }} minLength={50} onChange={e => setComment(e.target.value)} />
                </Form.Item>
                <Form.Item
                  className="mt-3"
                  wrapperCol={{
                    xs: {
                      offset: 8,
                      span: 18,
                    },
                    sm: {
                      offset: 7,
                      span: 18,
                    },
                    lg: { offset: 8, span: 18 },
                  }}
                >
                  <Button type="primary" htmlType="button" onClick={onClickApprove}>
                    Approve
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </div>
      </div>
    </>
  )
}
